<template>
  <div class="return-form">
    <div class="header">
      <span class="step">1</span>
      <span class="info">/2 基本信息</span>
    </div>
    <van-form
      class="outer-form"
      input-align="right"
      error-message-align="right"
      :scroll-to-error="true"
      @submit="onSubmit"
    >
      <div class="form">
        <div class="Quick-entry-box">
          <!-- 姓名和身份证号 -->
          <div class="name-idcard">
            <van-field
              autocomplete="off"
              v-model="parameters.submit_user"
              name="submit_user"
              label="退货人姓名"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入' }]"
            />
            <van-field
              autocomplete="off"
              v-model="parameters.submit_user_id_card"
              name="submit_user_id_card"
              label="身份证号"
              placeholder="请输入"
              :rules="[{ validator: submitUserIdCard, message: '请输入' }]"
            />
            <!-- <div class="cell">
              <span class="label">退货人姓名</span>
              <input class="cell-inp" v-model="parameters.submit_user" type="text" placeholder="请输入" />
            </div>
            <div class="cell">
              <span class="label">身份证号</span>
              <input class="cell-inp" v-model="parameters.submit_user_id_card" type="text" placeholder="请输入" />
            </div>-->
          </div>
          <!-- 录入 -->
          <div class="luRu-box">
            <div class="inner">
              <img class="luru-icon" src="../../../../assets/refund/icon_quickRecord.png" alt />
              <span class="text">快捷录入</span>
              <input
                ref="ocrinp1"
                class="ocr-input"
                type="file"
                accept="image/*"
                id="fileup"
                @change="OCR_handle('退货人')"
              />
            </div>
          </div>
        </div>
        <div class="private-info">
          提示: 提供游客身份证，用于实名办理退货，保障游客相关权益。
        </div>
        <div class="cell phone">
          <!-- <span class="label">联系电话</span>
          <div class="cell-right">
            <div class="verify-btn" @click="phoneShow = true">前往验证</div>
          </div>-->
          <van-field
            v-model="parameters.submit_user_tel"
            center
            readonly
            name="submit_user_tel"
            label="联系电话"
            placeholder
            :rules="[{ required: true, message: '请输入联系电话', trigger: 'onChange' }]"
          >
            <template #button>
              <div
                v-if="!parameters.submit_user_tel"
                class="phone_button"
                @click="phoneShow = true"
              >
                前往验证
                <van-icon
                  name="arrow"
                  v-if="parameters.submit_user_tel"
                  @click="succeedShow = true"
                />
              </div>
              <div @click="succeedShow = true" class="success" v-if="parameters.submit_user_tel">
                <van-icon class="success-icon" name="passed" @click="succeedShow = true" />
                <span>验证成功</span>
              </div>
              <!-- <div
                v-if="!parameters.submit_user_tel"
                class="phone_button"
                @click="phoneShow = true"
              >前往验证</div>
              <van-icon name="arrow" v-if="parameters.submit_user_tel" @click="succeedShow = true" />
              <div class="success" v-if="parameters.submit_user_tel">
                <van-icon class="success-icon" name="passed" @click="succeedShow = true" />
                <span>验证成功</span>
              </div>-->
            </template>
          </van-field>
        </div>
        <div class="cell not-require">
          <span class="label">是否本人购买</span>
          <div class="cell-right">
            <van-radio-group v-model="parameters.isSelf" direction="horizontal">
              <van-radio name="1">
                是
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
              <van-radio name="0">
                否
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
            </van-radio-group>
          </div>
        </div>
        <!-- 非本人购买时显示的部分 -->
        <div v-if="parameters.isSelf == 0" class="FeiBenRenGouMai-box">
          <div class="Quick-entry-box">
            <!-- 姓名和身份证号 -->
            <div class="name-idcard purchase">
              <!-- <div class="cell">
                <span class="label">购买人姓名</span>
                <input class="cell-inp" v-model="parameters.purchaser" type="text" placeholder="请输入" />
              </div>-->
              <van-field
                autocomplete="off"
                v-model="parameters.purchaser"
                name="purchaser"
                label="购买人姓名"
                placeholder="请输入"
                :rules="parameters.isSelf == 0 ? notMeForm.purchaser : []"
              />
              <van-field
                autocomplete="off"
                class="shenfenzhengField"
                v-model="parameters.paperwork"
                name="paperwork"
                label="身份证号"
                placeholder="请输入"
                :rules="parameters.isSelf == 0 ? notMeForm.paperwork : []"
              />
              <!-- <div class="cell">
                <span class="label">身份证号</span>
                <input class="cell-inp" v-model="parameters.paperwork" type="text" placeholder="请输入" />
              </div>-->
            </div>
            <!-- 录入 -->
            <div class="luRu-box">
              <div class="inner">
                <img class="luru-icon" src="../../../../assets/refund/icon_quickRecord.png" alt />
                <span class="text">快捷录入</span>
                <input
                  ref="ocrinp2"
                  class="ocr-input"
                  type="file"
                  accept="image/*"
                  id="fileup"
                  @change="OCR_handle('购买人')"
                />
              </div>
            </div>
          </div>

          <div class="cell telephone">
            <!-- <span class="label">联系电话</span>
            <input
              class="cell-inp"
              v-model="parameters.telephone"
              type="text"
              placeholder="请输入购买人电话号码"
              style="text-align: right;"
            />-->
            <van-field
              :class="parameters.telephone ? '' : 'no-error-message'"
              autocomplete="off"
              v-model="parameters.telephone"
              name="telephone"
              label="联系电话"
              type="tel"
              placeholder="请输入购买人电话号码"
              :rules="parameters.isSelf == 0 ? notMeForm.telephone : []"
            />
          </div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="divider"></div>
      <div class="form new_form">
        <!-- <div class="cell" @click="returnReasonPickerHandle">
          <span class="label">退货原因</span>
          <div class="cell-right">
            <span>{{ parameters.reasonsForReturn.name }}</span>
            <van-icon class="arrow" name="arrow" />
          </div>
        </div>-->
        <van-field
          readonly
          v-model="parameters.reasonsForReturn.name"
          name="refundReason"
          label="退货原因"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择' }]"
          right-icon="arrow"
          @click="returnReasonPickerHandle"
        />
        <div class="new_cell">
          <!-- <div class="new_cell_box" @click="purchaserPickerHandle">
            <span class="label">购买渠道</span>
            <div class="cell-right">
              <span>{{ parameters.wayBuying.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>-->
          <van-field
            readonly
            v-model="parameters.wayBuying.name"
            name="purchaseChannel"
            label="购买渠道"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择购买渠道' }]"
            right-icon="arrow"
            @click="purchaserPickerHandle"
          />
          <div
            class="new_cell_trip"
            v-show="parameters.wayBuying.id == 1 && !parameters.itineraryNo && !allNot"
          >
            <span @click.prevent="tripPickerHandle">+选择跟团行程单</span>
          </div>
        </div>
        <van-field
          v-if="parameters.wayBuying.id == 1 && parameters.itineraryNo"
          name="refundChannel"
          label="跟团行程单"
          :right-icon="itineraryArrow"
          disabled
          @click-right-icon="tripPickerHandle"
          :rules="parameters.wayBuying.id == 1 && !parameters.itineraryNo && !allNot ? itineraryRule : []"
        />
        <div class="itinerary-box">
          <div v-if="parameters.itineraryNo" class="itinerary-inner">
            <p class="itinerary-title">{{ parameters.lineName }}</p>
            <p class="itinerary-info">行程单号：{{ parameters.itineraryNo }}</p>
            <p class="itinerary-info">旅行社：{{ parameters.travelName }}</p>
            <p class="itinerary-info">出行时间：{{ parameters.travelTime }}</p>
          </div>
          <div v-if="parameters.wayBuying.id == 1 && allNot && !parameters.itineraryNo" class="itinerary-inner">
            <p class="itinerary-title">没有找到符合的行程单</p>
            <p class="itinerary-info mb12">
              需上传相关行程订单截图、照片等凭证
              <span style="color: red;">*</span>
            </p>
            <div class="upload-box">
              <upload :fileBizType="90" @fileuploadData="fileUploadData"></upload>
            </div>
          </div>
        </div>
        <van-field
          readonly
          v-model="parameters.returnMethod.name"
          name="refundChannel"
          label="退货方式"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择退货方式' }]"
          right-icon="arrow"
          @click="returnMethodPickerHandle"
        />
      </div>
      <div class="divider"></div>
      <div class="form">
        <div class="supplement-box">
          <p class="title">补充说明</p>
          <van-field
            class="textarea"
            autocomplete="off"
            v-model="parameters.refundContent"
            autosize
            name="refundContent"
            type="textarea"
            maxlength="500"
            placeholder="请输入"
            show-word-limit
            input-align="left"
          />
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="btn-box">
        <button type="submit">下一步</button>
      </div>
    </van-form>

    <!-- 退货原因弹框 -->
    <popList
      ref="reasonsReturnPicker"
      @select="selectReturnReason"
      @close="selectReturnReason"
      :datalist="reasonsReturnList"
      :header="'选择退货原因'"
    />
    <popList
      ref="purchaserPicker"
      @select="selectPurchaser"
      @close="selectPurchaser"
      :datalist="purchaserList"
      :header="'选择购买渠道'"
    />
    <popList
      ref="returnMethodPicker"
      @select="selectReturnMethod"
      @close="selectReturnMethod"
      :datalist="returnMethodList"
      :header="'选择退货方式'"
    />
    <listTrip
      ref="tripPicker"
      @select="selectTrip"
      @close="selectTrip"
      :datalist="TripList"
      :header="'选择需要关联的跟团行程单'"
    />
    <!-- <van-popup v-model="phoneShow" round position="bottom"> -->
    <van-overlay :show="phoneShow" @click="phoneShow = false" class="phone-overlay">
      <div class="phone_show" @click.stop>
        <van-form
          label-align="left"
          ref="phoneForm"
          input-align="left"
          label-width="60px"
          @submit="phoneSubmit"
          :validate-first="true"
        >
          <div class="title">
            <span>手机号验证</span>
            <img src="../../../../assets/refund/cross.png" alt @click="closePhoneShow" />
          </div>
          <div class="body">
            <van-field
              :style="{'border-bottom': noTelephone ? '1px solid red' : telephony.length > 0 ? '1px solid #666666' : '', }"
              class="telephony-field"
              autocomplete="off"
              type="digit" 
              v-model="telephony"
              name="telephony"
              label="+86"
              clearable
              placeholder="请输入退货人手机号"
            />
            <van-field
              autocomplete="off"
              class="verification-field"
              :style="{'border-bottom': noVerification ? '1px solid red' : verification.length > 0 ? '1px solid #666666' : '',}"
              v-model="verification"
              type="digit"
              name="verification"
              label
              :left-icon="verificationIcon"
              placeholder="请输入验证码"
            >
              <template #button>
                <van-count-down
                  style="color: #9DAOA4;"
                  ref="countDown"
                  v-if="countdown > 0"
                  :time="countdown"
                  format="sss"
                  @finish="finish"
                />
                <span
                  class="obtain-btn"
                  style="font-size: 16px;color: #36B374;font-weight: 400;"
                  v-else
                  @click="obtainClick()"
                >获取</span>
                <!-- <van-button v-else @click="obtainClick()" size="small" type="primary">获取</van-button> -->
              </template>
            </van-field>
            <div class="form_bottom"></div>
          </div>
          <div class="foot">
            <button type="submit">验证</button>
          </div>
        </van-form>
      </div>
    </van-overlay>
    <!-- </van-popup> -->

    <van-popup v-model="succeedShow" position="bottom" :closeable="true" :style="{ height: '75%' }">
      <div class="succeed_show">
        <div class="body">
          <div class="rest-icon">
            <!-- <van-icon name="checked" /> -->
            <img src="../../../../assets/refund/icon_successful@2x.png" alt />
          </div>
          <div class="successtext">手机号验证成功</div>
          <div class="phone-number">{{parameters.submit_user_tel}}</div>
          <div class="new-phone" @click="succeedShow = false; phoneShow = true">
            <div>新号码验证</div>
          </div>
        </div>
        <div class="foot">
          <div @click="succeedShow = false">关闭</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
    import popList from '../components/listPopup';
    import listTrip from '../components/listTrip';
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue';
    import { CountDown, Toast } from 'vant';
    import api from '../../../../service/modules/refund';
    import upload from '../components/upload';

    Vue.use(CountDown);
    Vue.use(Toast);
    export default {
        components: { popList, listTrip, upload },
        data () {
            return {
                verificationIcon: require('../../../../assets/refund/icon_Typecode@2x.png'),
                Imglist: [], // 上传图片列表
                itineraryArrow: require('../../../../assets/refund/icon_edit@2x.png'),
                check: {},
                itineraryRule: [
                    { required: true, message: '请选择行程单', trigger: 'onBlur' }
                ], // 行程单验证
                notMeForm: {
                    purchaser: [
                        { required: true, message: '请输入购买人姓名', trigger: 'onBlur' }
                    ],
                    paperwork: [
                        {
                            required: true,
                            message: '请输入正确的身份证',
                            trigger: 'onBlur',
                            validator: this.submitUserIdCard
                        }
                    ],
                    telephone: [
                        {
                            required: true,
                            message: '请输入正确的联系电话',
                            trigger: 'onBlur',
                            validator: this.testingTelephony
                        }
                    ]
                }, // 非本人购买部分表单验证
                reasonsReturnList: [
                    { name: '价格虚高', id: 1 },
                    { name: '瑕疵商品', id: 2 },
                    { name: '发票/收据不正规', id: 3 },
                    { name: '导游强制购物', id: 4 },
                    { name: '不喜欢', id: 5 },
                    { name: '其他', id: 6 }
                ], // 退货原因列表
                purchaserList: [
                    { name: '跟团期间购买', id: 1 },
                    { name: '⾃⼰出行购买', id: 2 }
                ], // 购买渠道
                returnMethodList: [], // 退货方式
                TripList: [],
                activeIcon: require('../../../../assets/refund/checkbox-select.png'),
                inactiveIcon: require('../../../../assets/refund/checkbox-defalut.png'),

                name: '',
                phoneShow: false,
                parameters: {},
                verification: '',
                noVerification: false, // 判断验证码是否为空
                telephony: '',
                noTelephone: false,
                countdown: 0,
                succeedShow: false,
                allNot: false, // true：选择了行程单里的以上都不是
                monitorKeyboard: null,
            };
        },
        computed: {
            ...mapGetters('refund', [
                'getRetreatRequest',
                'getDictType',
                'getCompanyList'
            ])
        },
        created () {
            this.setCompanyList();
            this.parameters = this._.cloneDeep(this.getRetreatRequest);
            this.setRegionList();
            this.setDictType().then(res => {
                if (res.SYS_REFUND_TYPES) {
                    res.SYS_REFUND_TYPES.forEach(element => {
                        this.returnMethodList.push({
                            name: element.name,
                            id: element.code
                        });
                    });
                }
            });
        },
        mounted(){
       },
        beforeDestroy(){
          this.monitorKeyboard.onEnd();
        },
        methods: {
            ...mapActions('refund', [
                'setRegionList',
                'setRetreatRequest',
                'setDictType',
                'setCompanyList'
            ]),
            fileUploadData (val) {
                this.Imglist = val;
            },
            // 获取行程单
            getItineraryListByIdCard (val) {
                const param = {
                    // idCard: '532325198902010351'
                    idCard: val
                };
                api.getItineraryListByIdCard(param).then(res => {
                    if (res.ret == 0) {
                        this.TripList = res.data.itineraryList;
                    }
                });
            },
            // 打开退货原因弹框
            returnReasonPickerHandle () {
                this.$refs['reasonsReturnPicker'].init(this.parameters.reasonsForReturn);
            },
            // 选择退货原因
            selectReturnReason (item) {
                this.parameters.refundReason = item.id;
                this.parameters.reasonsForReturn = item;
            },
            // 打开择购买渠道弹框
            purchaserPickerHandle () {
                this.$refs['purchaserPicker'].init(this.parameters.wayBuying);
            },
            // 选择购买渠道
            selectPurchaser (item) {
                this.parameters.purchaseChannel = item.id;
                this.parameters.wayBuying = item;
                this.allNot = (item.id !== 1)
                // 如果是自己出行购买清空行程单数据
                if (item.id === 2) {
                    this.parameters.travelName = ''
                    this.parameters.lineName = ''
                    this.parameters.travelTime = ''
                    this.parameters.itineraryNo = ''
                }
            },
            // 打开择退货方式弹框
            returnMethodPickerHandle () {
                const item = {
                    name: this.parameters.returnMethod.name,
                    id: this.parameters.refundType
                };
                this.$refs['returnMethodPicker'].init(item);
            },
            // 选择退货方式
            selectReturnMethod (item) {
                this.parameters.refundType = item.id;
                this.parameters.returnMethod = item;
            },

            // 选择行程单
            tripPickerHandle () {
                try {
                    // 如果是本人购买
                    if (this.parameters.isSelf == 1) {
                        if (!this.parameters.submit_user_id_card) {
                            return this.$toast('请输入身份证');
                        } else {
                            this.getItineraryListByIdCard(this.parameters.submit_user_id_card);
                            this.$refs['tripPicker'].init();
                        }
                    } else if (this.parameters.isSelf == 0) {
                        if (!this.parameters.paperwork) {
                            // 如果不是本人购买
                            return this.$toast('请输入身份证');
                        } else {
                            this.getItineraryListByIdCard(this.parameters.paperwork);
                            this.$refs['tripPicker'].init();
                        }
                    }
                } catch (err) {
                }
            },
            // 选择行程单
            selectTrip (item) {
                if (item !== -1) {
                    this.parameters.travelName = item.name;
                    this.parameters.lineName = item.route_name;
                    this.parameters.travelTime = item.team_start_date;
                    this.parameters.itineraryNo = item.team_id;
                } else {
                    // 如果选择了‘以上都不是’
                    this.allNot = true
                    this.$set(this.parameters, 'travelName', '')
                    this.$set(this.parameters, 'lineName', '')
                    this.$set(this.parameters, 'travelTime', '')
                    this.$set(this.parameters, 'itineraryNo', null)
                    // this.parameters.travelName = ''
                    // this.parameters.lineName = ''
                    // this.parameters.travelTime = ''
                    // this.parameters.itineraryNo = ''
                }
            },
            // ocr识别信息：https://blog.csdn.net/wxyf2018/article/details/89680042
            OCR_handle (type) {
                try {
                    let data = new FileReader()
                    let file
                    if (type === '退货人') {
                        file = this.$refs.ocrinp1.files[0];
                    } else if (type === '购买人') {
                        file = this.$refs.ocrinp2.files[0];
                    }
                    data.readAsDataURL(file)
                    data.onload = el => {
                        let formdata = new FormData();
                        formdata.append('file', file);
                        api.getIDCardInfo(formdata).then(res => {
                            if (res.ret === 0) {
                                if (type === '退货人') {
                                    this.parameters.submit_user = res.data.name;
                                    this.parameters.submit_user_id_card = res.data.idNum;
                                    this.$refs.ocrinp1.value = '';
                                } else if (type === '购买人') {
                                    this.parameters.purchaser = res.data.name;
                                    this.parameters.paperwork = res.data.idNum;
                                    this.$refs.ocrinp2.value = '';
                                }
                            }
                        });
                    };
                } catch (err) {
                    console.log(err);
                }
            },
            // 下一步
            onSubmit (values) {
                // this.Imglist = ['8a888bf47dea6834017dfad9d26d00cc']
                this.parameters.attach = this.Imglist.join(',')
                this.setRetreatRequest(this.parameters);
                // 如果是跟团购买
                if (this.parameters.wayBuying.id == 1) {
                    if (!this.parameters.itineraryNo && !this.allNot) {
                        return this.$toast('请选择行程单');
                    } else if (this.allNot && this.Imglist.length === 0) {
                        return this.$toast('请选择上传行程单截图');
                    } else {
                        this.$router.push({ path: '/refund/secondRefund' });
                    }
                } else {
                    this.$router.push({ path: '/refund/secondRefund' });
                }
            },
            phoneSubmit (values) {
              if (!this.telephony) {
                return this.noTelephone = true
              } else {
                this.noTelephone = false
              }
              if (!this.verification) {
                return this.noVerification = true
              } else {
                this.noVerification = false
              }

                try {
                    // console.log("啊吧啊吧 --- 验证验证码");
                    // Toast.loading({
                    //   duration: 3000, // 持续展示 toast
                    //   message: "加载中...",
                    //   forbidClick: true
                    // });
                    // Toast.clear();
                    // 验证验证码
                    const param = {
                        tel: this.telephony,
                        code: this.verification
                    }
                    api.verifySMS(param).then(res => {
                        if (res.ret != 0) {
                            // this.$toast('验证码输入错误，验证失败')
                        } else {
                            this.parameters.submit_user_tel = this.telephony
                            this.phoneShow = false;
                            this.succeedShow = true;
                            this.countdown = 0
                        }
                    })
                } catch (err) {
                    console.log(err);
                }
            },
            submitUserIdCard (value) {
                if (value) {
                    const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
                    return reg.test(value);
                } else {
                    return false;
                }
            },
            testingTelephony (value) {
                if (value) {
                    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
                    return reg.test(value);
                } else {
                    return true;
                }
            },
            // 点击x关闭手机号验证弹窗
            closePhoneShow () {
                this.phoneShow = false;
                this.telephony = '';
                this.verification = '';
            },
            obtainClick () {
                this.$refs.phoneForm
                    .validate('telephony')
                    .then(res => {
                        if (this.countdown === 0) {
                            this.countdown = 60 * 1000;
                        }
                        const param = {
                            tel: this.telephony
                        }
                        api.sendSMS(param).then(res => {
                            if (res.ret === 0) {
                                this.$toast('验证码已发送')
                            }
                        })
                        // 打开验证码发送开关
                        // const smsSwitchReq = api.smsSwitch({ onOff: 'on' })
                        // // 获取验证码
                        // smsSwitchReq.then(res => {
                        //   api.sendSMS(param).then(res => {
                        //     if (res.ret === 0) {
                        //       this.$toast("验证码已发送")
                        //     }
                        //   })
                        // })
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },
            finish () {
                this.countdown = 0;
            }
        }
    };
</script>
<style lang="less" scoped>
.return-form {
  .van-icon-arrow:before {
    font-size: 12px;
  }
  padding-bottom: 50px;
  min-height: 103vh;
  padding: env(
    safe-area-inset-bottom
  ); /* zero for all rectangular user agents */
  padding: env(
    Safe-area-inset-bottom
  ); /* 50px because UA properties are case sensitive */
  /deep/.phone-overlay {
    display: flex;
    align-items: center;
    background-color: rgba(0,0,0,0.30);


    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #CCCCCC;
      }
      .van-field__control:-moz-placeholder {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #CCCCCC;

      }
    .van-field__control:-ms-input-placeholder {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #CCCCCC;
      }
    // 验证码输入框样式
    // .verification {
    //   padding-top: 25px;
    //   .van-icon-smile-o {
    //     width: 55px;
    //     margin-right: 0;
    //   }
    // }
    // .phone-cell {
    //   padding-top: 43px;
    // }
    .phone_show {
      width: 100%;
      background: white;
      padding: 20px 0 42px;
      border-radius: 8px;

      .van-field__label{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        color: #171A1D;
      }

      .van-field__control {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }
      .title {
        display: flex;
        justify-content: space-between;
        color: #171a1d;
        font-size: 16px;
        font-weight: bold;
        padding: 0 16px;
        margin-bottom: 27px;
        img {
          width: 16px;
          height: 16px;
        }
      }
      .body {
        padding: 0 16px;
        .van-cell {
          padding: 16px 0;
          &:first-child {
            border-bottom: 1px solid #EDEDED;
          }
        }
      }
      /deep/.van-field__button button {
        color: #36b374;
        background-color: #ffffff;
        font-size: 16px;
        border: none;
      }
      /deep/.van-count-down {
        color: #9DA0A4;
        // background: #999999;
        font-size: 16px;
        border-radius: 10px;
        padding: 4px 8px;
      }
      .form_bottom {
        height: 40px;
      }

      /deep/.van-icon-smile-o {
        height: 100%;
        width: 60px;
        margin-right: 8px;
      }
      /deep/.van-icon-smile-o::before {
        content: " ";
        width: 20px;
        height: 100%;
        background: url(../../../../assets/refund/icon_Typecode@2x.png)
          no-repeat;
        background-size: 20px 20px;
        background-position: center;
      }

      .foot {
        padding: 0 24px;
        button {
          background-color: #36b374;
          width: 100%;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 48px;
          border-radius: 4px;
          border: 0;
        }
      }
    }
  }
  .header {
    background-color: #f8f9fc;
    padding: 13px 16px;
    font-size: 14px;
    .step {
      color: #333333;
      font-size: 16px;
    }
    .info {
      color: #999999;
    }
  }
  /deep/.outer-form {
    .van-field__label {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .form {
    padding: 0 16px;
    .Quick-entry-box {
      display: flex;
      justify-content: space-between;
      .name-idcard {
        margin-right: 11px;
        flex: 1;
        /deep/.van-field__error-message--right {
          display: none;
        }
        /deep/.van-field {
          padding: 16px 0;
        }
        /deep/.van-cell::after {
          left: 0;
          right: 0;
        }

        .cell {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
          border-bottom: 1px solid #f7f7f7;
          .label {
            font-size: 14px;
            color: #666666;
            &::after {
              content: "*";
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #F94F4E;
            }
          }
          .cell-inp {
            text-align: right;
          }
        }
      }
      .purchase {
        /deep/.van-field {
          background: #f8f9fc;
        }
        .shenfenzhengField::after {
          display: block;
        }
      }
      .luRu-box {
        padding-top: 15px;
        .inner {
          position: relative;
          background: #FFFFFF;
          border: 1px dashed #9BE3BE;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          width: 68px;
          height: 98px;
          .ocr-input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
          .luru-icon {
            width: 24px;
            height: 24px;
            margin-bottom: 3px;
          }
          .text {
            font-size: 10px;
            color: #36b374;
          }
        }
      }
    }
    .cell {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #f7f7f7;
      .label {
        font-size: 14px;
        color: #666666;
        &::after {
          content: "*";

          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.cell-right {
            .van-radio__label {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #171A1D;
          }
        .van-radio__icon {
          width: 18px;
          height: 18px;
        }
        .verify-btn {
          border-radius: 4px;
          border: 1px solid #36b374;
          padding: 0 10px;
          line-height: 22px;
          font-size: 12px;
          color: #36b374;
        }
        .arrow {
          font-size: 16px;
          vertical-align: sub;
          margin-left: 5px;
        }
      }
    }

    .phone {
      padding: 0;
      /deep/.van-field {
        padding: 20px 0;
        // overflow: auto;
      }
      /deep/.van-field__button {
        position: relative;
        .phone_button {
          background: #ffffff;
          border: 0.5px solid #36b374;
          border-radius: 4px;
          padding: 0 10px;
          line-height: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #36B374;
        }
        .success {
          position: absolute;
          top: 0px;
          right: 9px;
          display: flex;
          align-items: center;
          width: 85px;
          color: #36b374;
          font-size: 12px;
          transform: scale(0.8333);
          padding-top: 8px;
          justify-content: flex-end;
          .van-icon {
            top: 2px;
            margin-right: 4px;
          }
        }
      }
      /deep/.van-cell {
        line-height: normal;
      }
    }
    .new_cell {
      // border-bottom: 1px solid #f7f7f7;
      .new_cell_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        .label {
          font-size: 14px;
          color: #666666;
          &::after {
            content: "*";

            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #F94F4E;
          }
        }
        /deep/.cell-right {
      
          .verify-btn {
            border-radius: 4px;
            border: 1px solid #36b374;
            padding: 0 10px;
            line-height: 22px;
            font-size: 12px;
            color: #36b374;
          }
          .arrow {
            font-size: 16px;
            vertical-align: sub;
            margin-left: 5px;
          }
        }
      }
      .new_cell_trip {
        display: flex;
        justify-content: center;
        background: #f8f9fc;
        padding: 21px 0;
        margin: 0 16px;
        span {
          padding: 7px 28px;
          border: 0.5px solid #36b374;
          border-radius: 4px;
          color: #36b374;
        }
        // span::after{
        //   content: "*";
        //   color: red;
        // }
      }
    }
    .itinerary-box {
      padding: 0 16px;
      .itinerary-inner {
        background-color: #f8f9fc;
        border-radius: 2px;
        padding: 14px 16px 18px;
        .itinerary-title {
          font-size: 16px;
          color: #333333;
          font-weight: 500;
          margin-bottom: 12px;
        }
        .itinerary-info {
          font-size: 14px;
          color: #999999;
          font-weight: 400;
          &:not(:last-child) {
            margin-bottom: 10px;
            
          }
        }
        .mb12 {
          margin-bottom: 12px;
        }
      }
       /deep/.upload-box {
    .title {
      display: none;
      font-size: 14px;
      color: #171a1d;
      line-height: 14px;
      margin-bottom: 12px;
    }
    .van-uploader {
      width: 75px;
      height: 75px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        content: "";
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
    .uploadBox {
      margin-bottom: 0;
    }
  }
    }
    /deep/.FeiBenRenGouMai-box {
      background-color: #f8f9fc;
      padding: 0 17px 0 16px;
      margin-bottom: 13px;
      .van-field__control {
        color: #171A1D;
      }
      input {
        background: inherit;
      }
      .telephone {
        /deep/.van-field {
          background: #f8f9fc;
          padding: 0;
        }
        .no-error-message {
          .van-field__error-message {
            display: none;
          }
        }
      }
      .van-cell {
        background-color: #f8f9fc;
        padding: 0;
      }
    }
    .not-require {
      .label {
        &::after {
          content: "";
        }
      }
    }
    .supplement-box {
      position: relative;
      padding-top: 16px;
      padding-bottom: 0;
      .van-cell {
        background-color: #f8f9fb;
        padding: 16px 16px 10px;
      }
      /deep/.van-field__word-limit {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #CCCCCC;
        padding-right: 12px;
      }
      
      
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
            min-height: 120px;
            max-height: 320px;
          }
        .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
      /deep/.van-field {
        background: #f8f9fb;
      }
      .van-field__control {
        background: #f8f9fb;
        color: #171A1D;
      }
      
    }
    /deep/.van-field__label::after {
      content: "*";

      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #F94F4E;
      margin-left: 1px;
    }
  }
  /deep/.new_form {
    .van-icon-arrow:before {
      font-size: 12px;
    }
    padding: 0;
      .van-icon-arrow {
        font-size: 1px;
      }
    .van-field__error-message--right {
      display: none;
    }
    .van-cell {
      padding: 20px 16px;
    }
    .van-field__control {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #171A1D;
    }
  }
  .divider {
    height: 15px;
    background-color: #f8f9fc;
  }
  .btn-box {
    padding: 16px 16px 34px;
    background: #ffffff;
    display: flex;
    button {
      border-radius: 4px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      border: 0;
      background: #36b374;
      line-height: 48px;
      // padding: 16px 0;
      flex-basis: 100%;
    }
  }
}

.succeed_show {
  .body {
    padding: 0 24px;
    padding-top: 75px;
    /deep/.van-field__button {
      .obtain-btn {
        font-size: 16px;
        color: #36b374;
        font-weight: 400;
      }
    }
    .rest-icon {
      margin-bottom: 16px;
      img {
        width: 64px;
        height: 64px;
        margin: 0 auto;
      }
    }
    .successtext {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      margin-bottom: 12px;
    }
    .phone-number {
      font-size: 16px;
      color: #666666;
      font-weight: 400;
      margin-bottom: 51px;
    }
    .new-phone {
      text-align: center;
      margin-bottom: 146px;
      div {
        width: 104px;
        border: 1px solid #36b374;
        padding: 11px 0;
        text-align: center;
        font-size: 14px;
        color: #36b374;
        font-weight: 500;
        margin: 0 auto;
      }
    }
    div {
      text-align: center;
    }
  }
  .foot {
    padding: 0 24px;
    div {
      background-color: #36b374;
      width: 100%;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 48px;
      border-radius: 4px;
      border: 0;
    }
  }
}
/deep/.van-field__label {
  width: auto !important;
  margin-right: 31px;
}
/deep/.verification-field {
  border-bottom: 1px solid #EDEDED;
  .van-field__left-icon {
    display: flex;
    align-items: center;
    margin-right: 37px;
  }
}

.private-info {
  background-color: #ecf1f7;
  color: #1774d3;
  font-size: 14px;
  padding: 12px;
  border-radius: 4px;
  line-height: 20px;
  margin-top: 12px;
}
</style>
